import { render, staticRenderFns } from "./takaful.vue?vue&type=template&id=05d12070&scoped=true&"
import script from "./takaful.vue?vue&type=script&lang=js&"
export * from "./takaful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d12070",
  null
  
)

export default component.exports